import { TIconComponent } from 'transfix-icons/types'
import {
  UserIcon,
  CustomerIcon,
  LocationPinIcon,
  TruckIcon,
  PlusIcon,
  FlatBedIcon,
  DropTrailerIcon,
} from 'transfix-icons'

const ICONS = {
  UserIcon,
  CustomerIcon,
  LocationPinIcon,
  TruckIcon,
  PlusIcon,
  FlatBedIcon,
  DropTrailerIcon,
} as const

/**
 * Options for icons that can be used in <Autosuggest /> render options
 * when using `renderOption='withIcon'`
 */
export const ICONS_BY_NAME: Record<keyof typeof ICONS, TIconComponent> = ICONS
export type TIconName = keyof typeof ICONS_BY_NAME
